const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '实时推送',
    desc: '吃瓜爆料网App支持毫秒级推送，热点事件发生第一时间通知到位，确保你不会错过任何一个重磅爆料。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '地址永续',
    desc: '本站作为官方发布页持续维护，吃瓜爆料网最新地址实时同步更新，彻底告别收藏夹里失效链接的烦恼。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '内容全覆盖',
    desc: '从反差视频到塌房现场，从黑料爆料到八卦追踪，吃瓜爆料网站覆盖娱乐全品类，一站式满足吃瓜需求。',
  },
  {
    id: 4,
    icon: 'ri-user-voice-line',
    title: '匿名投稿',
    desc: '支持匿名爆料投稿机制，保护爆料人隐私安全。你的线索可能成为下一个引爆全网的热门话题。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">平台特色</h2>
          <p className="text-sm text-foreground-500">为什么百万用户选择吃瓜爆料网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div key={feature.id} className="bg-background-100 rounded-xl border border-background-200/70 p-6 text-center group hover:border-primary-200/50 transition-all cursor-default">
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-accent-50 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-accent-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}